import React from 'react';
// import { world_countries } from 'components/common/CountryCodes';

import { world_countries } from '../../../components/common/CountryCodes';

// const defaultDialCodeISO = (iso) => {

// 	if (iso === null || typeof iso === undefined) {
// 		iso = {
// 			name: "USA",
// 			code: "+1",
// 		}

// 	}

// 	return iso.name + '(' + iso.code + ')';

// }


const DisplayPhoneInput = (cdc) => {

	return (

		<div>
			<div className="container ml-1 form-group">


				<div className="col-11 ">

				<h6 className="font-italic">Country Dial-Code:</h6 >

				</div>

				<div className="col-11 ">


					<select id="cdc" className="form-control "  >
						<option >{"+"+cdc}</option>
						{world_countries.map(

							(el, index) => {

								return <option key={index} className="text-left"> {el.nm}({el.iso})</option>;
							}
						)

						}

					</select>
				</div>

			</div>

			<form>
				<div className="form-group container ml-1 row">

					<div className=" col-10 col-md-6  p-2"><h5 className="  font-italic">New  Phone #:</h5><div ><input type="number" className="form-control" placeholder='phone#' id="newPhone" /></div></div>
					<div className="  col-10 col-md-6 p-2"><h5 className="  font-italic">Confirm Phone #:</h5><div ><input type="number" className="form-control" placeholder='phone#' id="confirmPhone" /></div></div>

				</div>
			</form>






		</div>

	);
}

export default DisplayPhoneInput;